import { deserializeSuperjson } from '@lib/superjson';
import {
  EditableSnapQuote,
  EditSnapQuoteRequest,
} from '@snap-types/actions/edit-snap-quote';
import { buildSnapQuoteUrl } from '@ui/store/api-builder/build-url';
import {
  enhanceEndpoints,
  injectEndpoints,
} from '@ui/store/api-builder/inject-mutation';

const injectedApi = injectEndpoints({
  endpoints: (builder) => ({
    editSnapQuote: builder.query<EditableSnapQuote, EditSnapQuoteRequest>({
      transformResponse: deserializeSuperjson,
      query: ({ siteCode, quoteUuid }) => ({
        url: buildSnapQuoteUrl(siteCode, quoteUuid, 'edit'),
      }),
      providesTags: (_result, _error, args) => [
        { type: 'EditSnapQuoteBySiteCode', id: args.siteCode },
      ],
    }),
  }),
});

enhanceEndpoints({
  addTagTypes: ['EditSnapQuoteBySiteCode'],
});

declare module '@ui/store/data' {
  interface ApiTagTypesMap {
    EditSnapQuoteBySiteCode: 'EditSnapQuoteBySiteCode';
  }
}

export const editSnapQuote = injectedApi.endpoints.editSnapQuote;
export const useEditSnapQuoteQuery = editSnapQuote.useQuery;
